(function () {
  "use strict";

  const TARGET = 'properties[Create Your Own Title]';

  let rafId = null;

  function applyFix() {
    rafId = null;

    document
      .querySelectorAll(`.ymq-options-box[data-name="${TARGET}"]`)
      .forEach((box) => {
        // Hide the YMQ price span if present
        box.querySelectorAll(".ymq_option_price_span").forEach((el) => {
          el.style.display = "none";
        });

        // Fallback: hide any price-like element inside THIS box only
        box.querySelectorAll('[class*="price"], [id*="price"]').forEach((el) => {
          el.style.display = "none";
        });
      });
  }

  function scheduleFix() {
    if (rafId) return;
    rafId = requestAnimationFrame(applyFix);
  }

  // Initial run
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyFix);
  } else {
    applyFix();
  }

  // Observe YMQ re-renders safely (no infinite loop)
  const observer = new MutationObserver(scheduleFix);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
